import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { muskogeeConfig } from "./data";

export default function MuskogeePage() {
  return <CityPageTemplate config={muskogeeConfig} />;
}